import { ITheme } from '../../ui';

export const hoverBoxShadow = (theme: ITheme) => `
		transform: translate(2px, -1px);

		&::after {
			content: '';
			position: absolute;
			left: -4px;
			bottom: -4px;
			width: 100%;
			height: 92%;
			background-color: ${theme.color.brand};
			border-radius: ${theme.card.borderRadius};
			z-index: -1;
		}
	`;
